import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { AppAbility } from '../../utils/ability';

const AbilityContext = createContext<AppAbility>(undefined!);
const Can = createContextualCan(AbilityContext.Consumer);

export { Can, AbilityContext };
